const read_more_less_data = {}
function read_less(id){
  const richttls = document.querySelectorAll('.richttl');
  let content = ""
  if (id){
    const richttl = richttls[id]
    content = read_more_less_data[id]
    const content_array = content.split(" ")
    const reduced_content = content_array.splice(0,75).join(" ")
    richttl.innerHTML = reduced_content + `<span style="color:rgb(255, 136, 56);cursor: pointer;" onclick="read_more(${id})"> Voir plus...</span>`
    return false
  }
  richttls.forEach((richttl,index) => {
    if (read_more_less_data[index] == undefined){
      content = richttl.innerHTML
      read_more_less_data[index] = content
    }else{
      content = read_more_less_data[index]
    }
    const content_array = content.split(" ")
    if (content_array.length < 75){
      return
    }
    const reduced_content = content_array.splice(0,75).join(" ")
    const read_more_btn = `<span style="color:rgb(255, 136, 56);cursor: pointer;" onclick="read_more(${index})"> Voir plus...</span>`
    richttl.innerHTML = reduced_content + read_more_btn
  });
}
function read_more(id){
  const read_less_btn = `<span style="color:rgb(255, 136, 56);cursor: pointer;" onclick="read_less(${id})"> Voir moins...</span>`
  const richttls = document.querySelectorAll('.richttl');
  const richttl = richttls[id]
  const content = read_more_less_data[id]
  richttl.innerHTML = content + read_less_btn
  return false
}
function read_more_collection() {
  const collection = document.querySelector('div.rte.cl_desc.mt30');
  collection.style.maxHeight = null
  collection.style.height = collection.offsetHeight + 50+ "px"
  collection.removeChild(collection.lastChild);
  const gradient = document.createElement("div");
  gradient.innerHTML = `<span style="color:rgb(255, 136, 56);"> Voir moins...</span>`
  gradient.style.position = "absolute";
  gradient.style.cursor = "pointer";
  gradient.style.bottom = 0;
  gradient.style.left = 0;
  gradient.style.right = 0;
  gradient.style.height = "50px";
  gradient.style.padding = "0 0 0 50px";
  gradient.style.background = 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.891176538974965) 32%, rgba(255,255,255,1) 100%)';
  gradient.addEventListener("click",read_less_collection);

  collection.appendChild(gradient);
}
function read_less_collection() {
  const collection = document.querySelector('div.rte.cl_desc.mt30');
  collection.style.maxHeight = "300px";
  collection.style.overflow = "hidden";
  collection.style.position = "relative";
  // collection.removeChild(collection.lastChild);
  const gradient = document.createElement("div");
  gradient.innerHTML = `<span style="color:rgb(255, 136, 56);"> Voir plus...</span>`
  gradient.style.position = "absolute";
  gradient.style.cursor = "pointer";
  gradient.style.bottom = 0;
  gradient.style.left = 0;
  gradient.style.right = 0;
  gradient.style.height = "100px";
  gradient.style.padding = "50px";
  gradient.style.background = 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.891176538974965) 32%, rgba(255,255,255,1) 100%)';
  gradient.addEventListener("click",read_more_collection)

  collection.appendChild(gradient);
}

document.addEventListener('DOMContentLoaded',()=>{
  read_less()
  read_less_collection()
});